import React from 'react';
import cx from 'clsx';
import styles from '../GameDetailsTop.module.scss';
import { GameTileProps } from '../../../modular-grid/types';
import { isEqual } from 'src/utils/lodash-alternatives';
import { GameDetailsTopMessages } from '../GameDetailsTop';

interface GameDetailsTopInfoFeaturesPropTypes {
  game: GameTileProps;
  staticTexts: GameDetailsTopMessages;
}

const GameDetailsTopInfoFeatures: React.FC<GameDetailsTopInfoFeaturesPropTypes> = React.memo(
  ({ game, staticTexts }) => {
    const parsedGameFeatures = game.features && game.features.join(', ');

    return (
      <div
        data-testid="game-details-header-game-features"
        className={cx(
          styles.gameFeatures,
          !game.infoPageImages && styles.gameFeaturesFallbackColor
        )}
      >
        <p className={styles.gameFeaturesTitle}>
          {staticTexts.features}: {parsedGameFeatures}
        </p>
      </div>
    );
  },
  (
    prevProps: GameDetailsTopInfoFeaturesPropTypes,
    nextProps: GameDetailsTopInfoFeaturesPropTypes
  ) => isEqual(prevProps, nextProps)
);

export default GameDetailsTopInfoFeatures;
